import {Component, Input, OnInit} from '@angular/core';
import {Field} from '../../../../interfaces';
import {GalleryService} from '../../../../services/gallery.service';
import {ConfigAPIService} from '../../../../services/api/config-api.service';
import {ExportApiService} from '../../../../services/api/export-api.service';
import {NotificationService} from '../../../../services/notification.service';
import {environment} from '../../../../../environments/environment';
import { GalleryItem, ImageItem } from 'ng-gallery';
import {Observable, of} from 'rxjs';
import {BusinessUnitsService} from '@app/services/accounts/business-units.service';
import {map, take} from 'rxjs/operators';
import {AccountConfig} from '@app/interfaces/config/account.config';
import {KpdCodeApiService} from '@app/services/api/kpd-code-api.service';

@Component({
    selector: 'app-field-table-value',
    templateUrl: './field-table-value.component.html',
    styleUrls: ['./field-table-value.component.scss'],
    standalone: false
})
export class FieldTableValueComponent implements OnInit {
  @Input() field: Field<any>;

  public isOpened = false;

  public isDownloading = false;
  public accountConfig$: Observable<AccountConfig>;

  public vehicleName: string;
  public kpdName: string;
  kwToHpRatio = environment.kwToHpRatio;

  constructor(private gallery: GalleryService,
              private configAPIService: ConfigAPIService,
              private notificationService: NotificationService,
              private exportApi: ExportApiService,
              private businessUnitsService: BusinessUnitsService,
              private kpdCodeApi: KpdCodeApiService
  ) {
  }

  ngOnInit() {
    this.accountConfig$ = this.configAPIService.getAccountConfig();

    if (this.field.type === 'vehicle_model') {
      if (this.field.value) {
        this.configAPIService.getVehicleModel(this.field.value).subscribe((result) => {
          this.vehicleName = result.data.vehicleBrand.name + ' ' + result.data.name;
        });
      }
    }

    if (this.field.type === 'kpd_selector') {
      if (this.field.value) {
        this.kpdCodeApi.getByCode(this.field.value).subscribe((result) => {
          this.kpdName = result.name;
        }, (error) => {
          console.error('Error fetching KPD code details:', error);
          this.kpdName = null;
        });
      }
    }
  }

  showValue(field: Field<any>) {
    if (field.type === 'dropdown' || field.type === 'connected_dropdown' || field.type === 'bolha_location_v2' || field.type === 'njuskalo_location' || field.type === 'client_search') {
      return of(field.value[Object.keys(field.value)[0]]);
    }

    if (field.type === 'business_unit') {
      return this.businessUnitsService.getBusinessUnits().pipe(take(1),
        map((businessUnits) => {
          return businessUnits.find((businessUnit) => businessUnit.uuid === field.value)?.name || field.value;
        }));
    }

    return of(field.value.toString());
  }

  /**
   * Labels of every ticked item. A multi_checkbox value is grouped per section
   * ({sectionUuid: {itemKey: bool}}) and a field can have several sections, so
   * collect ticked items from all of them (not only the first).
   */
  prepareMultiCheckboxValues(field: Field<any>) {
    if (field.value !== null && field.value !== undefined) {
      const itemsMap = new Map<string, string>();
      for (const section of field.config?.sections ?? []) {
        for (const item of section?.items ?? []) {
          itemsMap.set(Object.keys(item)[0], Object.values(item)[0] as string);
        }
      }

      const arrayValues = [];
      for (const sectionValues of Object.values(field.value)) {
        for (const [key, value] of Object.entries(sectionValues ?? {})) {
          if (value === true && itemsMap.has(key)) {
            arrayValues.push(itemsMap.get(key));
          }
        }
      }
      arrayValues.sort();

      return arrayValues;
    }
  }

  openGallery(field: Field<any>, index: number) {
    const images: GalleryItem[] = field.value.map((upload) => {
      const file = upload.files?.[0];
      return new ImageItem({ src: file?.conversions.large, thumb: file?.conversions.thumbnail });
    });

    this.gallery.images = images;
  }

  toggleIsOpened() {
    this.isOpened = !this.isOpened;
  }

  toRepeaterField(subField: any, value: any) {
    const clone = {...subField, value};
    return clone;
  }

  downloadPhotos(field: Field<any>) {
    this.isDownloading = true;

    this.exportApi.downloadUploadsViaLink(field.value.map((item) => item.uploadUuid), field.config.label).subscribe(() => {
      this.isDownloading = false;
    }, (error) => {
      this.isDownloading = false;
      this.notificationService.showErrorAlert();
    });
  }

  getHpFromKw() {
    return Math.round(this.field.value * this.kwToHpRatio);
  }
}
